import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Banner = () => {
  return (
    <Box
      width={{ xs: "100%", sm: "70%" }}
      marginTop={{ xs: "25%", sm: "10%" }}
      marginLeft={{ xs: "0%", sm: "0%" }}
    >
      <Typography
        variant={"h2"}
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={"5%"}
        color={"#fff"}
      >
        Some of the{" "}
        <Typography
          component={"span"}
          variant={"h2"}
          color="#33E68C"
          fontWeight={700}
        >
          innovative
        </Typography>{" "}
        projects we have designed and developed for our clients.
      </Typography>
    </Box>
  );
};

export default Banner;
